import logo from './logo.svg';
import './App.css';
import DecJanFeb from './DecJanFeb'
import Home from './Home'
import MarchAprMay from './MarchAprMay'
import JuneJulyAug from './JuneJulyAug'
import SeptOctNov from './SeptOctNov'
import DecemberJanuary from './DecemberJanuary';
import Feb from './Feb'
import Statistics from './Statistics'
import Video from './Video'
import Feb122026 from './Feb122026';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar> </Navbar>
        <Routes>
          <Route path="/" element={<DecJanFeb />} />
          <Route path="Home" element={<DecJanFeb />} />
          <Route path="LoganOnly" element={<DecemberJanuary />} />
          <Route path="PictureFinder" element={<MarchAprMay />} />
          <Route path="LoganReviews" element={<JuneJulyAug />} />
          <Route path="HowLong" element={<SeptOctNov />} />
          <Route path="Feb12" element={<Feb />} />
          <Route path="Statistics" element={<Statistics />} />
          <Route path="Video" element={<Video />} />
          <Route path="Feb122026" element={<Feb122026 />} />
        </Routes>
      </BrowserRouter>
    </div >
  );
}

export default App;
